<template>
  <el-pagination
    background
    @size-change="sizeChange"
    @current-change="currentChange"
    :current-page="currentPage"
    :page-sizes="totalResult"
    :page-size="showCount"
    layout="total, sizes, prev, pager, next, jumper"
    :total="totalPage"
  ></el-pagination>
</template>

<script>
export default {
  props: {
    totalPage:{
      type: Number,
      default: 33
    }
  },
  data() {
    return {
      showCount: 10, // 总记录数容量   如:15条/页
      // totalPage: 0, // 总条数 共X条
      totalResult: [10, 15, 20, 25], // 选择每页多少条
      currentPage: 1, // 当前页
    };
  },
  methods: {
    // showCount 改变时会触发
    sizeChange(val) {
      this.showCount = val;
      this.currentPage = 1;
      this.$emit("sizeChange", this.showCount);
    },
    // currentPage 改变时会触发
    currentChange(val) {
      this.currentPage = val;
      this.$emit("currentChange", this.currentPage);
    },
  },
};
</script>

<style scoped lang="less">
</style>